import { useCallback, useEffect, useState } from 'react'
import { toast } from 'react-toastify'

// AUTH TOKEN START
import jwt_decode from 'jwt-decode'
import { ls, formatter } from 'utils'
import { LSKEY_TOKEN } from 'constants/app'
// AUTH TOKEN END

import { redemptionAPI } from 'api/icash'
import { MerchantLookupTypes } from 'types/merchanTxTypes'
import {
  IcashRedemptionTxFormTypes,
  IcashRedemptionTxFormSubmitValuesTypes,
  IcashRedemptionTxFormSubmitActionsTypes,
} from 'types/icashRedemptionTxTypes'
import { MemberDetail } from 'types/member'
import useMemberStore from 'store/member'
import { getTransactionsV2API } from 'api/transactions'

const PURCHASETXINITVAL: IcashRedemptionTxFormTypes = {
  creditValue: 0,
  externalTransactionId: 0,
  ident: '',
  pin: '',
  cashier: '',
  guid: '',
  storeId: 0,
  deviceCode: '',
  transactionDate: '',
  comments: '',
  traceNumber: 0,
  reasonId: 0,
}

export const useIcashRedemptionTx = (
  traderId: number,
  onCloseModal: () => void
): {
  member: MemberDetail | undefined
  isLoading: boolean
  initialValues: IcashRedemptionTxFormTypes
  isMerchantLookupToggle: boolean
  handleIsMerchantLookupToggle: () => void
  handleMerchantSet: (merchant: MerchantLookupTypes[]) => void
  handleSubmitIcashRedemptionTx: (
    values: IcashRedemptionTxFormSubmitValuesTypes,
    actions: IcashRedemptionTxFormSubmitActionsTypes
  ) => void
  handleClearIcashRedemptionTx: () => void
} => {
  // AUTH TOKEN START
  const authToken = ls.get(LSKEY_TOKEN)
  const decodeAuthToken: { username: string } = jwt_decode(String(authToken))
  const authTokenUsername = decodeAuthToken?.username || ''
  // AUTH TOKEN END
  // STATES
  const [isMerchantLookupToggle, isMerchantLookupToggleSet] =
    useState<boolean>(false)
  const [isLoading, isLoadingSet] = useState<boolean>(false)
  const [purchaseTxMerchant, purchaseTxMerchantSet] = useState<
    MerchantLookupTypes[]
  >([])
  const member = useMemberStore((state) => state.member)
  const [initialValues, initialValuesSet] =
    useState<IcashRedemptionTxFormTypes>({
      ...PURCHASETXINITVAL,
      cashier: authTokenUsername,
      externalTransactionId: formatter.externalIdentification(),
      ident: String(member?.cardNumber) || '',
    })

  const handleIsMerchantLookupToggle = useCallback(() => {
    isMerchantLookupToggleSet(!isMerchantLookupToggle)
  }, [isMerchantLookupToggle, isMerchantLookupToggleSet])

  const handleMerchantSet = useCallback(
    async (merchant: MerchantLookupTypes[]) => {
      try {
        purchaseTxMerchantSet(merchant)
        toast.success('Merchant Selected')
      } catch (error) {
        toast.error('Something went wrong.')
      }
    },
    [purchaseTxMerchantSet]
  )

  const handleSubmitIcashRedemptionTx = useCallback(
    async (
      values: IcashRedemptionTxFormSubmitValuesTypes,
      actions: IcashRedemptionTxFormSubmitActionsTypes
    ) => {
      isLoadingSet(true)
      try {
        if (String(values.externalTransactionId) === "") {
          values.externalTransactionId = initialValues.externalTransactionId + 1
        }
        await redemptionAPI(values)
        toast.success('iCash redemption successful.')
        // actions.setSubmitting(false)
        onCloseModal()
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        toast.error(message.outcomeUserMessage)
      }
      isLoadingSet(false)
    },
    [isLoadingSet]
  )

  const handleClearIcashRedemptionTx = useCallback(() => {
    initialValuesSet({ ...PURCHASETXINITVAL })
    toast.success('Filter successfully cleared.')
  }, [initialValuesSet])

  return {
    member,
    isLoading,
    initialValues,
    isMerchantLookupToggle,
    handleIsMerchantLookupToggle,
    handleMerchantSet,
    handleSubmitIcashRedemptionTx,
    handleClearIcashRedemptionTx,
  }
}
